import { createTheme } from '@mui/material/styles';
import { colors, typography } from './tokens';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: colors.primary,
      light: colors.primaryLight,
      dark: colors.primaryDark,
    },
    secondary: {
      main: colors.secondary,
      light: colors.secondaryLight,
      dark: colors.secondaryDark,
    },
    error: {
      main: colors.error,
    },
    background: {
      default: colors.background,
      paper: colors.surface,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
    divider: colors.divider,
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: typography.families.body,
    h1: {
      fontFamily: typography.families.heading,
      fontWeight: typography.weights.semibold,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: typography.families.heading,
      fontWeight: typography.weights.semibold,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: typography.families.heading,
      fontWeight: typography.weights.semibold,
      letterSpacing: '-0.02em',
    },
    h4: {
      fontFamily: typography.families.heading,
      fontWeight: typography.weights.semibold,
      letterSpacing: '-0.02em',
    },
    h5: {
      fontFamily: typography.families.heading,
      fontWeight: typography.weights.semibold,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontFamily: typography.families.heading,
      fontWeight: typography.weights.semibold,
      letterSpacing: '-0.02em',
    },
    button: {
      textTransform: 'none',
      fontWeight: typography.weights.semibold,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage:
            'linear-gradient(140deg, rgba(156,122,42,0.08) 0%, rgba(6,8,17,0) 45%)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(148, 163, 184, 0.12)',
          backgroundImage:
            'linear-gradient(160deg, rgba(110,84,24,0.16) 0%, rgba(6,8,17,0.2) 40%, rgba(6,8,17,0.4) 100%)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(15, 23, 42, 0.6)',
          borderRadius: 12,
        },
        notchedOutline: {
          borderColor: 'rgba(148, 163, 184, 0.28)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '12px 14px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingInline: 16,
          paddingBlock: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: typography.weights.semibold,
          color: colors.textSecondary,
        },
      },
    },
  },
});

export default theme;
